<template>
    <div class="trainServicesIndex">
        <banner :themeColor = 'themeColors'></banner>
        <div class="container">
            <div class="topTabBox">
                <div class="boxTit">线上课程学习中心</div>
                <div class="tabTit">
                    <div class="titItem" v-for="(item,titIndex) in onlineTitList" :key="item._id" :class="{active:item.active}" @click="tabTitClick(titIndex,item._id,'online')">
                        <div>{{ item.kcfl }}</div>
                        <div class="activeLine"></div>
                    </div>
                </div>
                <div class="tabContent">
                    <div class="contentItem" v-for="(item,index) in onlineContentList" :key="item.id" @click="goPage('./courseDetail',item._id)">
                        <div class="imgBox">
                            <img :src="commenUrl+ item.kctp" v-if="item.kctp" alt="">  
                            <img class="defaultImg" src="../../../assets/images/trainServices/defaultImg.png" v-else alt="">
                        </div>
                        <div class="tBox">
                            <div class="contentTit">{{ item.kcmc }}</div>
                            <div class="contentDesc">{{ item.kcjj }}</div>
                        </div>
                    </div>
                </div>
                <div class="paginationBox">
                    <el-pagination background layout="prev, pager, next" size="small"  @size-change="e=>{sizeChange(e,'online')}"
                        @current-change="e=>{currentChange(e,'online')}"
                        :page-size="pageInfo.pageSize" :total="pageInfo.count" />
                </div>
            </div>
            <div class="botTabBox">
                <div class="boxTit">线下培训公告中心</div>
                <div class="tabTit">
                    <div class="titItem" v-for="(item,titIndex) in offlineTitList" :key="item._id" :class="{active:item.active}" @click="tabTitClick(titIndex,item._id,'offline')">
                        <div>{{ item.pxfl }}</div>
                        <div class="activeLine"></div>
                    </div>
                </div>
                <div class="tabContent">
                    <div class="contentItem" v-for="(item,index) in offlineContentList" :key="item.id">
                        <div class="leftBox">
                            <div class="bigT">{{ item.day }}</div>
                            <div>{{ item.month }}<span class="gap">月</span>{{ item.year }}</div>
                        </div>
                        <div class="midBox" @click="goPage('./trainServicesDetail',item._id,item.status)">
                            <div class="tit">{{ item.pxmc }}</div>
                            <div class="desc">{{ item.pxjj }}</div>
                            <div class="btn colorBtn" v-if="item.status=='2'" @click="goPage('./trainServicesDetail/',item._id,item.status)">培训回顾</div>
                            <div class="btn" v-else @click="goPage('./trainServicesDetail',item._id,item.status)">立即报名</div>
                        </div>
                    </div>
                </div>
                <div class="paginationBox">
                    <el-pagination background layout="prev, pager, next" size="small"  @size-change="e=>{sizeChange(e,'offline')}"
                        @current-change="e=>{currentChange(e,'offline')}"
                        :page-size="pageInfo1.pageSize" :total="pageInfo1.count" />
                </div>
            </div>
        </div>
        <div class="btmBox">
            <div class="boxTit">定制化培训服务咨询</div>
            <customConsult :themeColor="themeColor" :offlineTitList="offlineTitList"></customConsult>
        </div>
    </div>
</template>
<script>
    import { ref, getCurrentInstance, reactive ,nextTick} from "vue";
    import { useRouter,useRoute } from "vue-router";
    import customConsult from "../components/trainForm.vue";
    import banner from '../components/banner.vue'
    export default {
        name: "trainServices",
        props:{
            themeColor: {
                type: String,
                default: 'blue'
            },
        },
        components: {customConsult,banner},
        setup() {

            const { proxy } = getCurrentInstance();
            const router = useRouter();
            const route = useRoute()
            const themeColors = ref('#fff')
            const pageInfo = ref({
                pageSize:8,
                pageNo:1,
                count:0
            })
            const pageInfo1 = ref({
                pageSize:6,
                pageNo:1,
                count:0
            })
            // 线上课程
            const onlineTitList = ref([])
            // 获取线上课程类型
            const getOnlineTypeList = ()=>{
                proxy.$request({
                    url: 'QPSTZX_PXFW_COURSESTYPELIST',
                    method: "post",
                    data:{}
                }).then((res) => {
                    console.log(res);
                    if(res.data.code=='000'){
                        onlineTitList.value = res.data.result
                        nextTick(()=>{
                            if(onlineTitList.value.length>0){
                                onlineTitList.value[0].active = true
                                getContentList( onlineTitList.value[0]._id)
                            }
                        })
                        
                    }
                }).catch((err) => {
                    console.log(err);
                })
            }
            getOnlineTypeList()
            //获取线上课程内容列表
            const onlineContentList = ref([])
            const getContentList = (id)=>{
                proxy.$request({
                    url: 'QPSTZX_PXFW_COURSESFINDPAGE',
                    method: "post",
                    data:{
                        "kclb": id,
                        "pageInfo": pageInfo.value
                    }
                }).then((res) => {
                    console.log(res);
                    if(res.data.code=='000'){
                        onlineContentList.value = res.data.result.list
                        pageInfo.value.pageNo = res.data.result.pageNo
                        pageInfo.value.pageSize = res.data.result.pageSize
                        pageInfo.value.count = res.data.result.count
                    }
                }).catch((err) => {
                    console.log(err);
                })
            }
            //类型切换
            const currentOnlineId = ref('')
            const currentOfflineId = ref('')
            const tabTitClick = (titIndex,id,type) => {
                if(type=='online'){
                    currentOnlineId.value = id;
                    onlineTitList.value.forEach((item,index)=>{
                        item.active = index==titIndex?true:false
                    })
                    pageInfo.value.pageNo = 1
                    getContentList(currentOnlineId.value)
                }else{
                    currentOfflineId.value = id;
                    offlineTitList.value.forEach((item,index)=>{
                        item.active = index==titIndex?true:false
                    })
                    pageInfo1.value.pageNo = 1
                    getOfflineContentList(currentOfflineId.value)
                }
            }
            //分页事件
            const sizeChange = (e,type) => {
                if(type=='online'){
                    if (pageInfo.value.pageSize == e) return;
                    pageInfo.value.pageSize = e;
                    getContentList(currentOnlineId.value)
                }else{
                    if (pageInfo1.value.pageSize == e) return;
                    pageInfo1.value.pageSize = e;
                    getOfflineContentList(currentOfflineId.value)
                }
                
            };
            const currentChange = (e,type) => {
                if(type=='online'){
                    if (pageInfo.value.pageNo == e) return;
                    pageInfo.value.pageNo = e;
                    getContentList(currentOnlineId.value)
                }else{
                    if (pageInfo1.value.pageNo == e) return;
                    pageInfo1.value.pageNo = e;
                    getOfflineContentList(currentOfflineId.value)
                }
            };
            // 线下培训
            const offlineTitList = ref([])
            // 获取线下培训类型
            const getOfflineTypeList = ()=>{
                proxy.$request({
                    url: 'QPSTZX_XXPX_TRAINTYPELIST',
                    method: "post",
                    data:{}
                }).then((res) => {
                    console.log(res);
                    if(res.data.code=='000'){
                        offlineTitList.value = res.data.result
                        nextTick(()=>{
                            if(offlineTitList.value.length>0){
                                offlineTitList.value[0].active = true
                                getOfflineContentList( offlineTitList.value[0]._id)
                            }
                        })
                    }
                }).catch((err) => {
                    console.log(err);
                })
            }
            getOfflineTypeList()
            //获取线下培训内容列表
            const offlineContentList = ref([])
            const getOfflineContentList = (id)=>{
                proxy.$request({
                    url: 'QPSTZX_XXPX_TRAINTFINDPAGE',
                    method: "post",
                    data:{
                        "pxfl": id,
                        "pageInfo": pageInfo1.value
                    }
                }).then((res) => {
                    console.log(res);
                    if(res.data.code=='000'){
                        offlineContentList.value = res.data.result.list.map(item=>{
                            const dateStr = item.pxkssj
                            if (!dateStr) return {...item, year: '', month: '', day: '' };
                            const normalizedStr = dateStr.replace(/-/g, '/');
                            const [datePart] = normalizedStr.split(' '); 
                            const [year, month, day] = datePart.split('/'); 
                            return {
                                ...item,
                                year: year || '',
                                month: month || '',
                                day: day || ''
                            };
                        })
                        pageInfo1.value.pageNo = res.data.result.pageNo
                        pageInfo1.value.pageSize = res.data.result.pageSize
                        pageInfo1.value.count = res.data.result.count
                    }
                }).catch((err) => {
                    console.log(err);
                })
            }
             //页面跳转
            const goPage = (url,id,status) => {
                let str = '?id='+id
                if(status){
                    str = '?id='+id+'&status='+status
                }
                window.open(url+str);
            };
            return {
                onlineTitList,
                tabTitClick,
                currentOnlineId,
                currentOfflineId,
                pageInfo,
                pageInfo1,
                onlineContentList,
                sizeChange,
                currentChange,
                offlineTitList,
                offlineContentList,
                goPage,
                themeColors
            }
        }
    }
</script>
<style lang="less" scoped>
.trainServicesIndex{
    width: 100%;
    background: #F7F7F7 ;
    box-sizing: border-box;
    padding-top: 50px;
    div{
        box-sizing: border-box;
        color: #191919;
        // font-size: 16px;
        font-family: PingFangSC, PingFang SC;
    }
    img{
        width: 100%;
        height: 100%;
    }
    .boxTit{
        font-weight: bold;
        font-size: 18px;
        color: #1A1A1A;
        line-height: 28px;
        text-align: center;
    }
    .container{
        .tabTit{
            display: flex;
            justify-content: center;
            flex-wrap: wrap;
            margin-bottom: 20px;
            .titItem{
                font-weight: 400;
                font-size: 14px;
                color: #191919;
                margin:0 10px;
                cursor: pointer;
                text-align: center;
                .activeLine{
                    width: 24px;
                    height: 3px;
                    display: inline-block;
                }
                &.active{
                    font-weight: 600;
                    .activeLine{
                        background: #191919;
                    }
                }
            }
        }
        .paginationBox{
            display: flex;
            justify-content: center;
            margin-top: 20px;
        }
        .topTabBox{
            margin: 0 14px;
            .boxTit{
                padding: 20px 0 12px;
            }
            .tabContent{
                min-height: 82px;
                .contentItem{
                    box-sizing: border-box;
                    font-weight: 400;
                    cursor: pointer;
                    display: flex;
                    margin-bottom: 12px;
                    .imgBox{
                        width: 142px;
                        height: 82px;
                        background: #EEF1FF;
                        border-radius: 10px;
                        overflow: hidden;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        margin-right: 14px;
                        .defaultImg,img{
                            width: 142px;
                            height: 82px;
                        }
                    }
                    .tBox{
                        width: calc(100% - 184px);
                        padding-top: 8px;
                    }
                    .contentTit{
                        font-weight: 600;
                        font-size: 14px;
                        color: #1A1A1A;
                        line-height: 20px;
                        height: 20px;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        margin-bottom: 5px;
                     }
                    .contentDesc{
                        font-weight: 400;
                        font-size: 12px;
                        color: #5C5C5C;
                        line-height: 22px;
                        height: 44x;
                        display: -webkit-box;
                        -webkit-box-orient: vertical;
                        -webkit-line-clamp: 2;
                        overflow: hidden;
                        text-overflow: ellipsis;
                    }
                }
            }
        }
        .botTabBox{
            margin: 0 14px;
            .boxTit{
                padding: 20px 0 12px;
            }
            .tabTit{
                margin-bottom: 12px;
            }
            .tabContent{
                min-height: 159px;
                margin: 0 auto;
                .contentItem{
                    width: 100%;
                    height: 159px;
                    padding: 15px 10px;
                    background: linear-gradient( 133deg, #FFFFFF 0%, rgba(255,255,255,0.39) 100%);
                    border-radius: 16px;
                    display: flex;
                    margin-bottom: 10px;
                    .leftBox{
                        width:50px;
                        height: 100%;
                        display: flex;
                        flex-direction: column;
                        gap: 3px;
                        align-items: center;
                        font-weight: 500;
                        font-size: 10px;
                        color: #595959;
                        line-height: 14px;
                        padding-top: 32px;
                        .bigT{
                            font-weight: bold;
                            font-size: 18px;
                            line-height: 23px;
                            color: #191919;
                        }
                        .gap{
                            margin-right: 3px;
                        }
                    }
                    .midBox{
                        flex: 1;
                        margin-left: 10px;
                        cursor: pointer;
                        .tit{
                            font-weight: 600;
                           font-size: 16px;
                            color: #1A1A1A;
                            line-height: 22px;
                            margin-bottom: 8px;
                            max-width: 268px;
                            white-space: nowrap;
                            overflow: hidden;
                            text-overflow: ellipsis;
                        }
                        .desc{
                            font-weight: 500;
                            font-size: 12px;
                            color: #5C5C5C;
                            line-height: 20px;
                            height: 60px;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            display: -webkit-box;
                            -webkit-line-clamp: 3;
                            -webkit-box-orient: vertical; 
                            margin-bottom: 12px;
                        }
                        .btn{
                            width: 82px;
                            height: 26px;
                            color: #191919;
                            border-radius: 17px;
                            border: 1px solid #191919;
                            text-align: center;
                            line-height: 24px;
                            font-size: 12px;
                            cursor: pointer;
                            background: transparent;
                        }
                        .colorBtn{
                            background: #191919;
                            color: #FFFFFF;
                        }
                    }
                }
            }
        }
    }
    .btmBox{
        margin:0 14px;
        padding-bottom: 1px;
        .boxTit{
            padding: 30px 0 15px;
            text-align: left;
        }
    }
}
</style>